import { createRouter as createVueRouter, createWebHistory } from "vue-router";
import MyPublicHotelPage from '@/pages/MyPublicHotelPage';
import IAmPartnerPage from '@/pages/IAmPartner';
import IAmPublicSpeakerPage from '@/pages/IAmPublicSpeaker';
import NotFound from '@/pages/PageNotFoundPage';
import StartPage from '@/pages/StartPage';


export default function createRouter() {
  return createVueRouter({
    routes: [
      {
        path: '/',
        name:'start',
        component: StartPage
      },
      {
        path: '/my-hotel/:hotelId',
        name: 'mypublichotel',
        component: MyPublicHotelPage
      },
      {
        path: '/i-am-partner/:hotelId',
        name: 'publicpartner',
        component: IAmPartnerPage
      },
      {
        path: '/i-am-speaker/:eventSpeakerId',
        name: 'myPublicSpeakerPage',
        component: IAmPublicSpeakerPage
      },
      {
        path: "/:notFound",
        component: NotFound,
      },
     ],
    history: createWebHistory(process.env.BASE_URL)
  })
}